export const CARD_PATTERNS = {
  CardholderName: /^[a-zA-Z\s'-]+$/,
  CardNumber: /^\d{4}-\d{4}-\d{4}-\d{3,4}$/,
  CardNumberMaskChars: /[-_]/g,
  NonDigits: /\D/g,
  AmexPrefix: /^3[47]/,
  Cvv: /^\d{3,4}$/,
  ZipCode: /^[0-9]{5}$/,
  ExpirationDate: /^(0[1-9]|1[0-2])\/([0-9]{4})$/
}

export const CARD_IMAGES = {
  Accepted: 'https://cdn.saraplus.com/images/logos/CCAccepted_1.0.png',
  Invalid: 'https://cdn.saraplus.com/images/RedX_1.1.png',
  Amex: 'https://cdn.saraplus.com/images/logos/Amex_1.0.png',
  Visa: 'https://cdn.saraplus.com/images/logos/Visa_1.0.png',
  MasterCard: 'https://cdn.saraplus.com/images/logos/MasterCard_1.0.png',
  Discover: 'https://cdn.saraplus.com/images/logos/Discover_1.0.png'
}
